module.exports = __webpack_public_path__ + "img/empty-state-graphic.b6d4b95c.png";